import request from 'services/request';

export async function ExchageRatesMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/ExchangeRate/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,

    data,
  });
}
